import { CardinalDirection } from '../../../api.js';
var Direction;
(function (Direction) {
    Direction["TOP"] = "Top";
    Direction["BOT"] = "Bottom";
    Direction["LEFT"] = "Left";
    Direction["RIGHT"] = "Right";
    Direction["FRONT"] = "Front";
    Direction["BACK"] = "Back";
})(Direction || (Direction = {}));
const direction_name_map = {
    [Direction.TOP]: CardinalDirection.TOP,
    [Direction.BOT]: CardinalDirection.BOTTOM,
    [Direction.LEFT]: CardinalDirection.LEFT,
    [Direction.RIGHT]: CardinalDirection.RIGHT,
    [Direction.FRONT]: CardinalDirection.FRONT,
    [Direction.BACK]: CardinalDirection.BACK
};
export const ORTHOGRAPHIC_CAMERA_DESCRIPTION = {
    name: 'orthographic-camera-description',
    is_enabled: true,
    initiate_tabs: [
        {
            tag: 'Cameras',
            setup: (tab, camera) => {
                const container = tab.get_container('🎥 ' + camera.name, { is_collapsed: !camera.debug_geometry });
                container.custom.watch('checkbox', {
                    name: 'Show Debug Gizmo',
                    get: () => !!camera.debug_geometry,
                    set: (v) => {
                        if (v) {
                            camera.create_debug_geometry();
                        }
                        else {
                            camera.remove_debug_geometry();
                        }
                    }
                });
                if (camera.debug_geometry) {
                    const gizmo_config = container.container('Gizmo Config');
                    gizmo_config.watch(camera.debug_geometry, 'always_update');
                    gizmo_config.watch(camera.debug_geometry.frustum, 'is_enabled', { name: 'Show Frustum' });
                    if ('set_pan_limits' in camera) {
                        gizmo_config.watch(camera.debug_geometry.camera, 'show_pan_limits');
                    }
                }
                const position = container.container('position_on_plane');
                position.custom.watch('number', {
                    name: 'x',
                    get: () => camera.position_on_plane.x,
                    set: (x) => {
                        const y = camera.position_on_plane.y;
                        camera.position_on_plane = { x: x, y: y };
                    }
                });
                position.custom.watch('number', {
                    name: 'y',
                    get: () => camera.position_on_plane.y,
                    set: (y) => {
                        const x = camera.position_on_plane.x;
                        camera.position_on_plane = { x: x, y: y };
                    }
                });
                container.custom.setter('number', {
                    name: 'set_size',
                    initial_value: 1,
                    set: (v) => { camera.size = v; },
                    is_collapsed: true
                });
                const direction = container.container('set_direction', { is_collapsed: true });
                let selected_direction = Direction.TOP;
                direction.custom.select('direction', Object.values(Direction), {
                    get: () => selected_direction,
                    set: (v) => {
                        selected_direction = v;
                    }
                });
                direction.button('Set', { on_click: () => camera.set_direction(direction_name_map[selected_direction]) });
                const projection = container.container('Projection');
                projection.custom.watch('number', { name: 'aspect_ratio', get: () => camera.projection.get_aspect_ratio() });
                projection.watch(camera.projection, 'left', { is_readonly: true });
                projection.watch(camera.projection, 'right', { is_readonly: true });
                projection.watch(camera.projection, 'top', { is_readonly: true });
                projection.watch(camera.projection, 'bottom', { is_readonly: true });
                projection.watch(camera.projection, 'near', { is_readonly: true });
                projection.watch(camera.projection, 'far', { is_readonly: true });
                if ('set_pan_limits' in camera) {
                    const limits = container.container('limits', { is_collapsed: true });
                    // Pan Limits Setter
                    const pan_limits_value = {
                        min: { x: -1, y: 0 },
                        max: { x: 1, y: 2 }
                    };
                    const pan_limits = limits.container('pan', { is_collapsed: true });
                    const min = pan_limits.container('min');
                    min.watch(pan_limits_value.min, 'x');
                    min.watch(pan_limits_value.min, 'y');
                    const max = pan_limits.container('max');
                    max.watch(pan_limits_value.max, 'x');
                    max.watch(pan_limits_value.max, 'y');
                    pan_limits.button('Set', { on_click: () => camera.set_pan_limits(pan_limits_value) });
                    limits.button('Clear Limits', { on_click: () => camera['clear_all_limits']() });
                }
            },
            dependencies: (camera) => {
                return [() => !!camera.debug_geometry]; // Rerender if debug geometry value changes.
            }
        }
    ]
};
//# sourceMappingURL=OrthographicCameraDescription.js.map